<template>

  <section class="bg-grey">
    <div class="container page-container">
      <div class="content">

        <div class="row m-0">
          <div class="col-12">
            <h2 class="section-title page-title h2 text-center text-black h2-caslon f-44">ทำความรู้จักกับ Engineering Plastic</h2>
            <p class="section-description ">
              In various industries All have to choose raw materials that are beneficial to business products. In
              particular, there are many types of plastic materials to choose from as appropriate, including engineering
              plastic. It is an important type of plastic that was invented to meet specific production needs. A full set of
              requirements can be set. So where did this type of plastic come from? Nagase will explain to you the
              definition of what engineering plastic is.
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary" style="padding-bottom: 74px">
    <div class="container">
      <div class="page-content">
        <div class="content pt-4">

          <ContentsTextWithImage
            title="What is Engineering Plastic ?"
            image-url="/pages/products/engineering-plastics/engg.jpg"
            :contents="[
              'Engineering plastics are a group of plastics or synthetic polymers that can be customized in structure or chemical composition as required by the manufacturer. whether to increase strength Increase the toughness of the plastic texture. increase corrosion resistance Flammability heat resistance high impact resistance, etc., for use in specific applications, such as replacing metal materials such as gears in automobile parts. or used in electrical parts computer parts, etc. This group of plastics is classified as a “high-value plastic.” in order to obtain the appropriate application qualifications for engineering work. and molded into various products through molds. Examples of products that require engineering plastic are machine parts. Metal replacement parts such as gears, electric appliance parts, car parts, etc.',
            ]"
            is-white-content="true"
            left-width="39.821%"
            right-width="60.179%"
          />

        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container page-container">
      <div class="page-content">
        <div class="entry-content">
          <div class="row m-0">
            <div class="col-12 text-color-paragraph">

              <div class="content">
                <h2 class="text-primary">Types of Engineering Plastic for all industries.</h2>
              </div>

              <div class="content text-color-paragraph">

                <h3 class="text-primary">Polyamide or Nylon (PA)</h3>
                <p class="mb-0">Polyamide, or nylon (PA), is a plastic obtained from the polymerization process. (Polymerization) with additives, or filters and additives, to meet the manufacturer’s specifications.</p>
                <p class="mb-0">Engineering plastics</p>
                <p>have good properties when it comes to withstanding high temperatures above the average of 200 ⁰C and electrical current.especially in the automotive industry, which can be divided into various types of polyamide, for example.</p>
                <p>&nbsp;</p>

                <ul class="pb-0 mb-0">
                  <li>Polyamide 6 (PA6)is a type of engineering plastic that is widely used. It has the ability to withstand high heat. because it has a melting point of 223 ⁰C</li>
                </ul>

                <p class="mb-0 ">Polyamide 66 (PA66)</p>
                <p>is the most popular engineering plastic. Most industries choose to use it instead of metal parts. because it is strong and resistant to high heat, with a melting point of up to 255 ⁰C</p>

                <h2 class="text-primary">Polybutylene Terephthalate (PBT)</h2>
                <p>Polybutylene Terephthalate (PBT) is an engineering plastic with properties similar to polyethylene terephthalate (PET), but with superior mechanical properties such as toughness, flexibility, strength, and impact resistance. In addition, it also has the ability to recover well from impacts.</p>

                <h2 class="text-primary">Polycarbonate (PC)</h2>
                <p>Polycarbonate is another type of plastic that is popular in all types of industries. including being used in engineering plastics as well, with features that are resistant to impact as well. Strong and durable but lightweight, aluminum has a high melting point and can be used to produce complex parts.</p>

              </div>

              <div class="content">

                <h2 class="text-primary">Types of Additives to improve the properties of Engineering Plastic</h2>
                <p>The purpose of engineering plastics is to customize them to meet the manufacturer’s specifications. Therefore, there are important additives that can be divided into three main types:</p>

                <ul>
                  <li>
                    <p class="mb-0 text-color-paragraph">Filler substance</p>
                    <p class="mb-0 text-color-paragraph" style="line-height: 24px">is a substance used to increase the amount of plastic so that it is firmer and thicker. for mechanical properties that reduce the fragility of the surface This method can help reduce the cost of using plastic resin to a certain extent.</p>
                  </li>
                  <li>
                    <p class="mb-0 text-color-paragraph">Reinforcements</p>
                    <p class="mb-0 text-color-paragraph" style="line-height: 24px">is a substance that enhances the mechanical properties of plastics. for better impact resistance Examples of plastics that have been added Reinforcements such as fiberglass plastics, glass fiber-reinforced plastics, etc.</p>
                  </li>
                </ul>

                <p class="mb-0 text-color-paragraph" style="margin-top: -10px">Using additives to add more properties</p>
                <p>is a way to customize the properties of plastics. in order to qualify as needed, such as adding substances that protect against UV rays, adding heat-resistant substances, adding anti-aging additives, adding color, etc.</p>

                <p>Engineering Plastic is a material that is very important to every industry. because you can choose to customize various features. on demand Make use of the creation of high-quality products. and conform to the standard as it should be. Therefore, choosing the right material for the product is an important problem that entrepreneurs must understand well in order to grow their businesses steadily.entrepreneurs must understand well in order to grow their businesses steadily.</p>

              </div>
    
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
useHead({
  title: "Engineering Plastic คืออะไรสำคัญต่อธุรกิจอย่างไร | NAGASE",
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/engineering-plastics`,
    }
  ]
})
</script>

<style scoped>
.page-title {
  padding-top: 80px;
  padding-bottom: 30px;
}

.page-container .section-description {
  font-family: 'Myriad-Pro';
  font-weight: 400;

  margin-bottom: 65px;
  line-height: 1.8;
  letter-spacing: -.2px;
  font-size: 17px;
  color: #5a5d67;
}

.page-content {
  padding: 60px 0 0;
}

.text-color-paragraph{
  color:#7a7a7a !important;
}
</style>
